// no baseURI

// object to store loaded and loading chunks
// undefined = chunk not loaded, null = chunk preloaded/prefetched
// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
var installedChunks = {
	"/js/app": 0,
	"assets/front/css/brickred": 0,
	"assets/front/css/brown": 0,
	"assets/front/css/black": 0,
	"assets/front/css/style": 0,
	"assets/front/css/yellow": 0,
	"assets/front/css/voiltsky": 0,
	"assets/front/css/orange": 0,
	"assets/front/css/darkgray": 0,
	"assets/front/css/darkblue": 0,
	"assets/front/css/seapink": 0,
	"assets/front/css/lightferozi": 0,
	"assets/front/css/moss": 0,
	"assets/front/css/ferozi": 0,
	"assets/front/css/parrot": 0,
	"assets/front/css/smokegray": 0,
	"assets/front/css/lightpink": 0,
	"assets/front/css/lightbrown": 0,
	"assets/front/css/panetone": 0,
	"assets/front/css/red": 0,
	"assets/front/css/pink": 0,
	"assets/front/css/lightblue": 0,
	"assets/front/css/bilobaflower": 0,
	"assets/front/css/darkbrown": 0,
	"assets/front/css/purple": 0,
	"assets/front/css/green": 0,
	"assets/css/style": 0
};

// no chunk on demand loading

// no prefetching

// no preloaded

// no HMR

// no HMR manifest

__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);

// install a JSONP callback for chunk loading
var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
	var [chunkIds, moreModules, runtime] = data;
	// add "moreModules" to the modules object,
	// then flag all "chunkIds" as loaded and fire callback
	var moduleId, chunkId, i = 0;
	if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
		for(moduleId in moreModules) {
			if(__webpack_require__.o(moreModules, moduleId)) {
				__webpack_require__.m[moduleId] = moreModules[moduleId];
			}
		}
		if(runtime) var result = runtime(__webpack_require__);
	}
	if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
	for(;i < chunkIds.length; i++) {
		chunkId = chunkIds[i];
		if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
			installedChunks[chunkId][0]();
		}
		installedChunks[chunkId] = 0;
	}
	return __webpack_require__.O(result);
}

var chunkLoadingGlobal = self["webpackChunk"] = self["webpackChunk"] || [];
chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));